import { api } from 'domains/api';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import { Reschedule } from './types';
import { ResolvedTimeZone } from 'domains/timezone';
import { ApiError } from 'domains/api/errors';
import { useMutation } from 'react-query';
import { useUserClientsWithActiveClient } from 'domains/auth/UserClientsWrapper/useUserClients';

export interface DateTimeEntry {
  dateTime: Date;
}

export interface AddRecurringAppointmentsDto {
  dates: DateTimeEntry[];
  calendarID: string;
  clientFirstName: string;
  clientLastName: string;
  contactEmail: string;
  contactPhone: string;
  contactTimeZone?: ResolvedTimeZone;
  userTimezone: string;
  therapistEmail: string;
  leadId?: string;
}

export const addRecurringAppointments = (
  clientId: string,
  payload: AddRecurringAppointmentsDto,
  leadId?: string,
): Promise<Reschedule> => {
  const url = getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.appointments.clients[':clientId'].recurring, {
    clientId,
  });

  const payloadWithLeadId = {
    ...payload,
    leadId,
  };

  return api.baseAnonymous.post(
    url,
    payloadWithLeadId,
  );
};


export const useAddRecurringAppointmentMutation = () => {
  const { activeClientId } = useUserClientsWithActiveClient();
  
  return useMutation<Reschedule, ApiError, AddRecurringAppointmentsDto>(
    async (payload) => {
      return addRecurringAppointments(activeClientId, payload);
    }
  );
};
